import PillarPage from "./PillarPage";

// Re-export PillarPage for /guias/pequenas-bolinhas-no-penis route
export default PillarPage;
